var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import naoEncontrado from "../assets/nao-encontrado.svg";
export var NaoEncontrado = function (_a) {
    var title = _a.title, subtitulo = _a.subtitulo, noMargin = _a.noMargin;
    return (_jsxs(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "center", mt: noMargin ? "0" : "-10rem", sx: { backgroundColor: "white" }, padding: "2rem", gap: "1rem" }, { children: [_jsx("div", __assign({ style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                } }, { children: _jsx("img", { src: naoEncontrado, alt: "ilustra\u00E7\u00E3o", style: { width: "8.125rem" } }) })), _jsx(Typography, __assign({ fontSize: "1.5rem", fontWeight: "500" }, { children: title !== null && title !== void 0 ? title : "Nenhuma informação para ser exibida no momento." })), _jsx(Typography, __assign({ fontSize: "1.125", fontWeight: "400", color: "textSecondary" }, { children: subtitulo }))] })));
};
